import { ReloadOutlined } from '@ant-design/icons';
import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import { Button, Divider, InputNumber, Space } from 'antd';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { renderUpdatedAtMessage } from '../../fragments/updated-at-message';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { type RootState } from '../../reducers';
import {
  ordersLoadByOrderStatusCodes,
  ordersReset,
} from '../../reducers/orders/reducer';
import { SPACING } from '../../theme/tokens';
import OrdersTable from './orders-table';

function OrdersLayout({
  orderStatusTypeCodes,
}: {
  orderStatusTypeCodes: EOrderStatus[];
}): React.ReactElement {
  const dispatch = useAppDispatch();
  const ordersState = useSelector((s: RootState) => s.Orders);
  const tagsState = useSelector((s: RootState) => s.Tags);
  const currencyState = useSelector((s: RootState) => s.Currency);

  const [ordersLimit, setOrdersLimit] = React.useState(100);

  useEffect((): void => {
    dispatch(ordersReset());
  }, []);

  return (
    <Space size={SPACING.lg} orientation="vertical" style={{ width: '100%' }}>
      <Space
        size={SPACING.lg}
        align="center"
        separator={<Divider orientation="vertical" />}
      >
        <Space.Compact>
          <Button type="default" style={{ pointerEvents: 'none' }}>
            Limit
          </Button>
          <InputNumber
            type="number"
            value={ordersLimit}
            min={1}
            defaultValue={100}
            onChange={(limit: number | null): void =>
              setOrdersLimit(Number(limit))
            }
          />
        </Space.Compact>

        <Button
          type={!ordersState.orders ? 'primary' : 'default'}
          onClick={(): void => {
            dispatch(
              ordersLoadByOrderStatusCodes(orderStatusTypeCodes, ordersLimit),
            );
          }}
          disabled={ordersState.inProcess}
        >
          Reload all <ReloadOutlined />
        </Button>

        {renderUpdatedAtMessage(
          ordersState.updatedAt,
          ordersState.inProcess,
          (): boolean => ordersState.orders !== undefined,
        )}
      </Space>

      <OrdersTable
        Orders={ordersState}
        Tags={tagsState}
        Currency={currencyState}
      />
    </Space>
  );
}

export default OrdersLayout;
